"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _tree_classname_map = _interopRequireDefault(require("./config/tree_classname_map"));

var _tree_props = require("./tree_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var genNodeTree = _spauiUtils.nodeTree.genNodeTree,
    CHECKED = _spauiUtils.nodeTree.CHECKED,
    UNCHECKED = _spauiUtils.nodeTree.UNCHECKED;
var haveJQuery = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.jQuery === 'function';

/**
 * 树状选择类
 * @example
 * 更详细的案例代码可参考Demo
 *
 * 设计思路:
 *
 * 组件内部不保存状态, 所有的数据与状态由父组件通过props传入
 * 每次render都会遍历整个树, 时间复杂度为O(n)
 * 因为树的结构比较特殊, 如果其中一个底层叶子节点选中, 可能会导致整条树枝的元素都是半选的状态
 *
 * 组件渲染流程:
 * 1. 遍历由父组件传入的整个的树状数据
 * 2. 生成NodeTree, NodeTree的节点以 this._treeNodeStruct 为结构模板
 * 3. 深度遍历仅需要展示的那条路径的节点
 *
 * onChange事件:
 * 1. 以勾选的节点TreeNode开始, 向上更新父节点链
 * 2. 以勾选的节点TreeNode开始, 向下递归更新子节点
 * 3. 生成新的 checkedIds, 抛出到父组件,由父组件传入重新render
 *
 * onClick事件:
 * 1. 获取点击的节点的所在的层级
 * 2. 生成新的 expandNodeIds, 抛出到父组件, 由父组件传入重新render
 */

/**
 * @class
 */
var Tree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tree, _PureComponent);

  function Tree(props) {
    var _this;

    _classCallCheck(this, Tree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tree).call(this, props)); // value 和 TreeNode 的映射, 可以从这里快速获取到任意一个 TreeNode对象: {value: TreeNode}

    _defineProperty(_assertThisInitialized(_this), "handleCheckAllChange", function (event) {
      var childrenNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var treeNode = _this.valueTreeNodeMap[event.target.value];
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          isAutoCheckedParent = _this$props.isAutoCheckedParent,
          oldCheckedIds = _this$props.value,
          valueType = _this$props.valueType,
          multiple = _this$props.multiple,
          unrelated = _this$props.unrelated;
      var newCheckedIds = [];
      var newCheckIdsMap = {};
      var result = [];

      var _addChildNodeValue = function addChildNodeValue() {};

      var finalResult = [];
      var valueIndex = -1; // 单选不支持

      if (!multiple) {
        return false;
      }

      if (unrelated) {
        newCheckedIds = (0, _spauiUtils.isArray)(oldCheckedIds) ? (0, _spauiUtils.cloneArray)(oldCheckedIds) : [];

        if (event.target.checked === false) {
          childrenNodes.map(function (item) {
            if (item && !item.disabled && (item.value || typeof item.value === 'number') && !item.not_allow_selected && !(typeof item.isAllowSelected !== 'undefined' && !item.isAllowSelected)) {
              valueIndex = (0, _spauiUtils.indexOf)(newCheckedIds, item.value);

              if (valueIndex > -1) {
                newCheckedIds.splice(valueIndex, 1);
              } // 删除当前节点


              delete _this.checkedIdsMap[item.value];
            }

            return item;
          });
        } else if (event.target.checked === true) {
          childrenNodes.map(function (item) {
            if (item && !item.disabled && (item.value || typeof item.value === 'number') && !item.not_allow_selected && !(typeof item.isAllowSelected !== 'undefined' && !item.isAllowSelected)) {
              valueIndex = (0, _spauiUtils.indexOf)(newCheckedIds, item.value);

              if (valueIndex < 0) {
                newCheckedIds.push(item.value);
              }

              _this.checkedIdsMap[item.value] = true;
            }

            return item;
          });
        }

        newCheckedIds.map(function (item) {
          result.push(item);
          return item;
        });
      } else {
        if (event.target.checked === false) {
          childrenNodes.map(function (item) {
            if (item && !item.disabled && (item.value || typeof item.value === 'number') && !item.not_allow_selected && !(typeof item.isAllowSelected !== 'undefined' && !item.isAllowSelected)) {
              // 删除当前节点, 删除父节点链条上的节点, 删除当前节点的子节点
              delete _this.checkedIdsMap[item.value];

              _this.deleteParentsFromCheckedIds(item, childrenNodes);

              _this.deleteChildsFromCheckedIds(item);
            }

            return item;
          });
        } else if (event.target.checked === true) {
          childrenNodes.map(function (item) {
            if (item && !item.disabled && (item.value || typeof item.value === 'number') && !item.not_allow_selected && !(typeof item.isAllowSelected !== 'undefined' && !item.isAllowSelected)) {
              // 这里要考虑两种情况, 通过 props.isAutoCheckedParent 开关 来控制
              // 1. 子节点全选, 自动选中父节点, 删除子节点
              // 2. 子节点全选, 不自动选上父节点,  当选上父节点时, 才选择父节点并且删除子节点
              _this.checkedIdsMap[item.value] = true;

              if (isAutoCheckedParent) {
                // 情况1,自动选中父节点, 删除子节点
                _this.addParentsToCheckedIds(item);
              } else {
                // 情况2,选上当前的节点, 把当前节点的子节点都删除了
                _this.deleteChildsFromCheckedIds(item);
              }
            }

            return item;
          });
        } // newCheckedIds 需要按照用户实际操作的顺序排列id, 分两步: 剔除CheckedIds中已删除的id, 添加新选中的id
        // 先剔除已删除的id


        if ((0, _spauiUtils.isArray)(oldCheckedIds)) {
          newCheckedIds = oldCheckedIds.filter(function (item) {
            return !!_this.checkedIdsMap[item];
          });
          newCheckedIds.forEach(function (item) {
            newCheckIdsMap[item] = true;
          });
        } // 遍历checkedIdsMap中的新增加的id


        for (var key in _this.checkedIdsMap) {
          if (key && !newCheckIdsMap[key] && _this.checkedIdsMap[key]) {
            newCheckedIds.push(key);
          }
        }

        if (valueType === 'child') {
          _addChildNodeValue = function addChildNodeValue() {
            var parentNodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var childNodeResult = arguments.length > 1 ? arguments[1] : undefined;
            var childrenNodes = parentNodeData.childrenNodes || [];

            if (parentNodeData.value) {
              if (childrenNodes.length < 1) {
                childNodeResult.push(parentNodeData.value);
              } else {
                childrenNodes.map(function (item) {
                  if (item.value && _this.valueTreeNodeMap[item.value]) {
                    _addChildNodeValue(_this.valueTreeNodeMap[item.value], childNodeResult);
                  }

                  return item;
                });
              }
            }
          }; // 回传最底层子节点


          newCheckedIds.map(function (item) {
            _addChildNodeValue(_this.valueTreeNodeMap[item] || {}, result);

            return item;
          });
        } else {
          newCheckedIds.map(function (item) {
            if (_this.valueTreeNodeMap[item] && _this.valueTreeNodeMap[item].parent_id && (0, _spauiUtils.indexOf)(newCheckedIds, _this.valueTreeNodeMap[item].parent_id) > -1) {// 如果父节点也是选中的，那子节点这个就不返回了
            } else {
              result.push(item);
            }

            return item;
          });
        }
      } // 最后返回valueTreeNodeMap本身自己的value


      result.map(function (item) {
        if (_this.valueTreeNodeMap[item] && _this.valueTreeNodeMap[item].value) {
          finalResult.push(_this.valueTreeNodeMap[item].value);
        } else {
          finalResult.push(item);
        }

        return item;
      });

      if ((0, _spauiUtils.isFunction)(onChange)) {
        // 标记是全选按钮，标记不能去掉
        event.target.checkAll = true;
        onChange(event, finalResult, treeNode, _this.valueTreeNodeMap);
      }
    });

    _this.valueTreeNodeMap = {}; // 把checkedIds转换为一个map:  {value: true || false}

    _this.checkedIdsMap = {}; // 当前组件展开的branch数量, 设置这两变量是为判断了当有展开子节点操作, 自动滚动到最右侧

    _this.lastBranchCount = 0;
    _this.isNeedScrollRight = false;

    _this.nullList();

    _this.setTreeNodeValue(props);

    _this.scopeScrollTimeout = null;
    _this.state = {
      showBeginIndexMap: {}
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.setSelectListClassName = _this.setSelectListClassName.bind(_assertThisInitialized(_this));
    _this.handleColumnScroll = _this.handleColumnScroll.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * 挂载完成后回调onRender,setBranchHeight
   * @private
   */


  _createClass(Tree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setBranchHeight();
      this.setSelectListClassName();
      this.updateWindowResize();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setTreeNodeValue(nextProps);
    }
    /**
     * update完成之后 调用setBranchHeight调整高度
     * @private
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setBranchHeight(); // 自动滚动到最右边, 滚动完成清除isNeedScrollRight标识

      if (this.isNeedScrollRight) {
        this.scrollToRight();
        this.isNeedScrollRight = false;
      }

      this.setSelectListClassName();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeWindowResize();
      this.nullList();
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _tree_classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "handleColumnScroll",
    value: function handleColumnScroll(event, parentNode) {
      var _this2 = this;

      var scrollData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var scrollHeight = arguments.length > 3 ? arguments[3] : undefined;
      var childrenNodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var index = arguments.length > 5 ? arguments[5] : undefined;
      var _this$props2 = this.props,
          onColumnScroll = _this$props2.onColumnScroll,
          theNumberOfDisplay = _this$props2.theNumberOfDisplay,
          _this$props2$displayT = _this$props2.displayTimes,
          displayTimes = _this$props2$displayT === void 0 ? 2 : _this$props2$displayT,
          _this$props2$displayI = _this$props2.displayItemHeight,
          displayItemHeight = _this$props2$displayI === void 0 ? 55 : _this$props2$displayI;
      var _this$state$showBegin = this.state.showBeginIndexMap,
          showBeginIndexMap = _this$state$showBegin === void 0 ? {} : _this$state$showBegin;
      var scrollTop = scrollData[0] || 0;
      var scrollBottom = scrollData[1] || 0;
      var scrollVisibleHeight = scrollBottom - scrollTop || event.target.clientHeight;
      var dataLength = childrenNodes.length || 0;
      var scopeIndex = index,
          newShowBeginIndexMap = {},
          getShowBeginIndex = null,
          theNumberOfDisplayInterval = Math.floor(theNumberOfDisplay / displayTimes),
          newState = {},
          lastShowBeginIndex = 0;

      if (theNumberOfDisplayInterval < 2) {
        theNumberOfDisplayInterval = 2;
      }

      if ((scopeIndex || typeof scopeIndex === 'number') && theNumberOfDisplay > 0 && dataLength > theNumberOfDisplay) {
        // 获取索引数据
        getShowBeginIndex = function getShowBeginIndex() {
          var topSpace = (theNumberOfDisplay - Math.ceil(scrollVisibleHeight / displayItemHeight)) / 2 * displayItemHeight; // 减去可视范围是希望别刚刚好就是顶住scrollTop

          var result = Math.floor((scrollTop - topSpace) / displayItemHeight);

          if (result < 0) {
            result = 0;
          } else if (result > dataLength - theNumberOfDisplay) {
            result = dataLength - theNumberOfDisplay;
          }

          return result;
        };

        newShowBeginIndexMap = (0, _spauiUtils.objectAssign)(showBeginIndexMap);
        lastShowBeginIndex = showBeginIndexMap[scopeIndex + '_' + parentNode.key] || 0; // 每5个就触发一下开始展示索引

        if (getShowBeginIndex() % theNumberOfDisplayInterval === 0 && lastShowBeginIndex !== getShowBeginIndex()) {
          newShowBeginIndexMap[scopeIndex + '_' + parentNode.key] = getShowBeginIndex();
          lastShowBeginIndex = getShowBeginIndex();
          newState = {
            random: Math.random() + '' + new Date().getTime(),
            showBeginIndexMap: newShowBeginIndexMap
          };
        }

        this.setState(newState, function () {
          // 防止滚动条停下的时候，没有触发“每5个就展示的逻辑”
          clearTimeout(_this2.scopeScrollTimeout);
          _this2.scopeScrollTimeout = setTimeout(function () {
            if (Math.abs(lastShowBeginIndex - getShowBeginIndex()) > 1) {
              newShowBeginIndexMap = (0, _spauiUtils.objectAssign)(_this2.state.showBeginIndexMap);
              newShowBeginIndexMap[scopeIndex + '_' + parentNode.key] = getShowBeginIndex();

              _this2.setState({
                random: Math.random() + '' + new Date().getTime(),
                showBeginIndexMap: newShowBeginIndexMap
              });
            }
          }, 10);
        });
      }

      if ((0, _spauiUtils.isFunction)(onColumnScroll)) {
        onColumnScroll(event, parentNode, scrollData, scrollHeight, childrenNodes);
      }
    }
  }, {
    key: "nullList",
    value: function nullList() {
      // 当前组件的dom
      this.domRef = null;
      this.selectListDom = null;
      this.branchWrap = null;
      this.scopeTransitionTimeoutByUseCss = null;
    } // 渲染节点value

  }, {
    key: "setTreeNodeValue",
    value: function setTreeNodeValue() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$fieldNames = props.fieldNames,
          fieldNames = _props$fieldNames === void 0 ? {} : _props$fieldNames,
          _props$data = props.data,
          data = _props$data === void 0 ? [] : _props$data;
      var _fieldNames$nodeField = fieldNames.nodeFieldName,
          nodeFieldName = _fieldNames$nodeField === void 0 ? 'options' : _fieldNames$nodeField,
          _fieldNames$valueFiel = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel === void 0 ? 'value' : _fieldNames$valueFiel,
          _fieldNames$parentFie = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie === void 0 ? 'parent_id' : _fieldNames$parentFie,
          _fieldNames$labelFiel = fieldNames.labelFieldName,
          labelFieldName = _fieldNames$labelFiel === void 0 ? 'desc' : _fieldNames$labelFiel,
          _fieldNames$disabledF = fieldNames.disabledFieldName,
          disabledFieldName = _fieldNames$disabledF === void 0 ? 'disabled' : _fieldNames$disabledF; // 渲染一层一层结构dom

      var renderTreeLevel = function renderTreeLevel() {
        var levelData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var level = arguments.length > 1 ? arguments[1] : undefined;

        if ((0, _spauiUtils.isArray)(levelData)) {
          levelData.map(function (item) {
            if (item) {
              if (typeof item[valueFieldName] !== 'undefined' && typeof item.value === 'undefined') {
                item.value = item[valueFieldName];
              }

              if (typeof item[parentFieldName] !== 'undefined' && typeof item.parent_id === 'undefined' && level > 0) {
                item.parent_id = item[parentFieldName];
              }

              if (typeof item[nodeFieldName] !== 'undefined' && typeof item.options === 'undefined') {
                item.options = item[nodeFieldName];
              }

              if (typeof item[labelFieldName] !== 'undefined' && typeof item.desc === 'undefined') {
                item.desc = item[labelFieldName];
              }

              if (typeof item[disabledFieldName] !== 'undefined' && typeof item.disabled === 'undefined') {
                item.disabled = item[disabledFieldName];
              } // 遍历子节点


              if ((0, _spauiUtils.isArray)(item[nodeFieldName]) && item[nodeFieldName].length > 0) {
                renderTreeLevel(item[nodeFieldName], level + 1);
              }
            }

            return item;
          });
        }
      };

      if ((0, _spauiUtils.isArray)(data)) {
        renderTreeLevel(data, 0);
      }
    }
  }, {
    key: "updateWindowResize",
    value: function updateWindowResize() {
      if (haveJQuery) {
        jQuery(window).on('resize', this.setSelectListClassName);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
        window.addEventListener('resize', this.setSelectListClassName);
      }
    }
  }, {
    key: "removeWindowResize",
    value: function removeWindowResize() {
      if (haveJQuery) {
        jQuery(window).off('resize', this.setSelectListClassName);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
        window.removeEventListener('resize', this.setSelectListClassName);
      }
    }
    /**
     * 自适应调整各个branch的高度
     * 当多列且且列与列之间的高度不统一
     * 获取最高列的高度,再应用到每一列
     * @private
     */

  }, {
    key: "setBranchHeight",
    value: function setBranchHeight() {
      var _this$props$singleCol = this.props.singleColumnHeight,
          singleColumnHeight = _this$props$singleCol === void 0 ? '' : _this$props$singleCol;
      var classNameMap = this.getClassNameMap();

      if (!this.props.isAutoHeight || !this.branchWrap) {
        return false;
      }

      var container = this.branchWrap.parentNode;
      var fixHeight = 2;
      var branchs = this.branchWrap.querySelectorAll('.' + classNameMap.TreeScopeClassName); // 判断一下是否有container,branchs, 没有就直接return

      if (!container || branchs.length < 1) {
        return false;
      }

      branchs = Array.prototype.filter.call(branchs, function (item) {
        return item.style.width !== '0px';
      }); // 获取最高一列的高度

      var isElementInViewport = false;
      var maxHeight = Array.prototype.reduce.call(branchs, function (reduceMaxHeight, item) {
        var title = item.querySelector('.' + classNameMap.TreeScopeTitleClassName);
        var branch = item.querySelector('ul');
        var style = branch && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.getComputedStyle(branch) ? window.getComputedStyle(branch) : {};
        var titleStyle = title && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.getComputedStyle(title) ? window.getComputedStyle(title) : {};
        var marginTop = (parseInt(style.marginTop, 10) || 0) + (parseInt(titleStyle.marginTop, 10) || 0);
        var margintBottom = (parseInt(style.marginBottom, 10) || 0) + (parseInt(titleStyle.marginBottom, 10) || 0);
        var height = (parseInt(style.height, 10) || 0) + (parseInt(titleStyle.height, 10) || 0);
        var itemHeight = height + marginTop + margintBottom + fixHeight;
        var finalHeight = reduceMaxHeight;
        isElementInViewport = height > 0 || isElementInViewport;

        if (itemHeight > finalHeight) {
          finalHeight = itemHeight;
        }

        return finalHeight;
      }, 0); // 当组件没有被显示出来或者父元素被隐藏的时候, maxHeight是为22 , 显示异常
      // 需要加个默认的高度, 保证当组件被显示出来的时候是有个高度的

      if (!isElementInViewport) {
        maxHeight = 272;
      }

      if (branchs.length > 1) {
        // 如果有多列才对每列设置maxHeight
        container.style.height = maxHeight + 'px';
        Array.prototype.forEach.call(branchs, function (item) {
          item.style.height = maxHeight - fixHeight + 'px';
        });
      } else {
        // 如果只有一列的高度
        container.style.height = singleColumnHeight;
        Array.prototype.forEach.call(branchs, function (item) {
          item.style.height = singleColumnHeight;
        });
      }
    }
    /**
     * 当有横向滚动条之后, 点击自动滚动到最右侧
     * @private
     */

  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      var _this3 = this;

      var _this$props3 = this.props,
          useCss = _this$props3.useCss,
          _this$props3$scopeTra = _this$props3.scopeTransitionTimeByUseCss,
          scopeTransitionTimeByUseCss = _this$props3$scopeTra === void 0 ? 0 : _this$props3$scopeTra;

      if (this.branchWrap) {
        var parentNode = this.branchWrap.parentNode;
        var parentNodeScrollLeft = parseInt((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.getComputedStyle(parentNode).scrollLeft, 10);
        var scrollLeft = parseInt((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.getComputedStyle(this.branchWrap).width, 10) - parentNode.clientWidth;

        if (scrollLeft > 0 && parentNodeScrollLeft !== scrollLeft) {
          // 存在滚动条，则滚动到最右侧
          parentNode.scrollLeft = scrollLeft;
        } else {
          // 使用css的有可能是用的flex，所以需要看下实际的滚动条与宽度的对比，flex获取到的clientWidth一直都会是可视宽度而已
          if (useCss) {
            clearTimeout(this.scopeTransitionTimeoutByUseCss);
            this.scopeTransitionTimeoutByUseCss = setTimeout(function () {
              if (_this3.branchWrap.scrollWidth > 0) {
                scrollLeft = _this3.branchWrap.scrollWidth - _this3.branchWrap.clientWidth;
              }

              if (scrollLeft > 0) {
                parentNode.scrollLeft = scrollLeft;
              }
            }, scopeTransitionTimeByUseCss);
          }
        }
      }
    }
    /**
     * 点击节点事件响应
     * @private
     * @param event
     * @returns {Tree}
     */

  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var value = event.currentTarget.getAttribute('data-value');
      var treeNode = this.valueTreeNodeMap[value];
      var _this$props4 = this.props,
          onClick = _this$props4.onClick,
          expandNodeIds = _this$props4.expandNodeIds,
          fieldNames = _this$props4.fieldNames,
          asyncGetNodeData = _this$props4.asyncGetNodeData;
      var nodeFieldName = fieldNames.nodeFieldName;
      var _this$state$showBegin2 = this.state.showBeginIndexMap,
          showBeginIndexMap = _this$state$showBegin2 === void 0 ? {} : _this$state$showBegin2;
      var newExpandNodeIds,
          updateIndex,
          newShowBeginIndexMap = {},
          key = '',
          deeplevel = event.currentTarget.getAttribute('data-deeplevel');
      var isNeedAsyncGetNodeData = false;

      if (!treeNode) {
        return;
      } // 自定义的CheckBox我们会用到label和input标签
      // 点击label的时候，事件冒泡一次，同时会触发关联的input的click事件
      // 导致事件再次冒泡，这里我们不需要input触发的第二次冒泡. (如果有更好的方式处理, 请修复这里)


      if (event.target.nodeName === 'INPUT') {
        return;
      }

      if (!deeplevel) {
        deeplevel = treeNode.deepLevel;
      } // 更新一下expandNodeIds, 先从expandNodeIds截取 deepLevel 前面的元素, 再设置当前更新的节点到expandNodeIds中


      if (deeplevel) {
        updateIndex = parseInt(deeplevel, 10) || 0;
        newExpandNodeIds = expandNodeIds.slice(0, updateIndex);
        newExpandNodeIds[updateIndex - 1] = treeNode.key;
      } // 切换的时候要保留展示数据
      // 不展示的就都回到0


      for (key in showBeginIndexMap) {
        if (key.indexOf('0') === 0 || key.slice(0) < deeplevel) {
          newShowBeginIndexMap[key] = showBeginIndexMap[key];
        }
      }

      newExpandNodeIds.map(function (item, index) {
        if (showBeginIndexMap[index + 1 + '_' + item]) {
          newShowBeginIndexMap[index + 1 + '_' + item] = showBeginIndexMap[index + 1 + '_' + item];
        }

        return item;
      });
      this.setState({
        showBeginIndexMap: newShowBeginIndexMap
      });

      if (treeNode.load_option === 1 && asyncGetNodeData && !(treeNode[nodeFieldName] && treeNode[nodeFieldName].length > 0)) {
        isNeedAsyncGetNodeData = true;
      }

      if ((0, _spauiUtils.isFunction)(onClick)) {
        onClick(event, newExpandNodeIds, treeNode, this.valueTreeNodeMap, isNeedAsyncGetNodeData);
      }
    }
    /**
     * 判断兄弟节点是否都处于勾选状态
     * @private
     * @param treeNode
     * @returns {null|*}
     */

  }, {
    key: "allSiblingNodeIsSelected",
    value: function allSiblingNodeIsSelected(treeNode) {
      var parentNode = treeNode.parentNode;
      return parentNode && parentNode.childrenNodes && parentNode.childrenNodes.every(function (item) {
        if (item.key === treeNode.key) {
          // 除去当前节点,因为要判断的是兄弟节点
          return true;
        } // 如果有任意一个兄弟节点状态不为 checked, 就返回false


        return item.status === CHECKED;
      });
    }
    /**
     * 取消勾选节点, 要更新 checkedIds 父亲节点链条,步骤:
     * 1. 判断节点的兄弟节点是否都选中
     * 2. 如果都选中了, 删除了父亲节点,同时把兄弟节点选上
     * 3. 递归往上更新父节点链上的节点
     * @private
     * @param treeNode
     */

  }, {
    key: "deleteParentsFromCheckedIds",
    value: function deleteParentsFromCheckedIds(treeNode) {
      var _this4 = this;

      var deleteChildrenNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var parentNode = treeNode.parentNode;
      var deleteChildrenValue = []; // 如果父节点不存在或者父节点是不可选的, 就不继续处理了

      if (!parentNode || parentNode.not_allow_selected) {
        return null;
      } // 需要删掉的兄弟节点


      deleteChildrenNodes.map(function (item) {
        if (item && (item.value || typeof item.value === 'number')) {
          deleteChildrenValue.push(item.value);
        }

        return item;
      });

      if (this.allSiblingNodeIsSelected(treeNode)) {
        // 删除父亲节点
        delete this.checkedIdsMap[parentNode.value]; // 如果兄弟节点也要删掉，就不要给设置true

        parentNode.childrenNodes.map(function (item) {
          if (item.value !== treeNode.value && (0, _spauiUtils.indexOf)(deleteChildrenValue, item.value) < 0) {
            _this4.checkedIdsMap[item.value] = true;
          }
        });
        this.deleteParentsFromCheckedIds(parentNode);
      }
    }
    /**
     * 勾选节点, 要更新 checkedIds 父亲节点链条,步骤:
     * 1. 判断兄弟节点是否都选, 父节点可选且不在checkedIds里
     * 2. 选上父节点, 并把父节点的子节点都删除
     * 3. 递归往上更新父节点链上的节点
     * 4. 如果兄弟节点未全选, 添加当前节点, 删除当前节点的子节点
     * @private
     * @param treeNode
     * @returns {*}
     */

  }, {
    key: "addParentsToCheckedIds",
    value: function addParentsToCheckedIds(treeNode) {
      var parentNode = treeNode.parentNode;

      if (!parentNode) {
        return null;
      }

      if (this.allSiblingNodeIsSelected(treeNode) && parentNode.value && !parentNode.not_allow_selected && !this.checkedIdsMap[parentNode.value]) {
        // 选中父节点, 删除父节点所有子节点, 再递归更新父父节点
        this.checkedIdsMap[parentNode.value] = true;
        this.deleteChildsFromCheckedIds(parentNode);
        this.addParentsToCheckedIds(parentNode);
      } else {
        this.checkedIdsMap[treeNode.value] = true;
        this.deleteChildsFromCheckedIds(treeNode);
      }
    }
    /**
     * 把当前节点所有的子节点从 checkedIds 删除掉
     * 1. 遍历当前节点的所有子节点,生成childrenIds
     * 2. 从checkedIds删除 childrenIds中的元素
     * @private
     * @param treeNode
     */

  }, {
    key: "deleteChildsFromCheckedIds",
    value: function deleteChildsFromCheckedIds(treeNode) {
      var _this5 = this;

      var fieldNames = this.props.fieldNames;
      var nodeFieldName = fieldNames.nodeFieldName;
      var sourceData = treeNode.sourceData;

      var _traverseSourceData = function _traverseSourceData(data) {
        data[nodeFieldName] && data[nodeFieldName].map(function (item) {
          if (item.value) {
            delete _this5.checkedIdsMap[item.value];
          }

          _traverseSourceData(item);
        });
      };

      if (sourceData) {
        _traverseSourceData(sourceData);
      }
    }
  }, {
    key: "setSelectListClassName",
    value: function setSelectListClassName() {
      var showColumnsCount = this.getShowColumnsCount();
      var classNameMap = this.getClassNameMap();
      var className = '',
          classNameArr = [],
          selectListDOMRect = {};

      if (this.selectListDom) {
        classNameArr = (this.selectListDom.className || '').split(' ');
        selectListDOMRect = this.selectListDom.getBoundingClientRect() || {};
        classNameArr.map(function (item) {
          if (item !== classNameMap.TreeMoreScopeClassName) {
            className += ' ' + item;
          }

          return item;
        });

        if (!(0, _spauiUtils.isUndefined)(selectListDOMRect.width) && selectListDOMRect.width / showColumnsCount < 210) {
          className = className + ' ' + classNameMap.TreeMoreScopeClassName;
        }

        this.selectListDom.className = className;
      }
    }
  }, {
    key: "handleChange",

    /**
     * 节点勾选与取消事件响应
     * @private
     * @param event
     */
    value: function handleChange(event) {
      var _this6 = this;

      var treeNode = this.valueTreeNodeMap[event.target.value];
      var _this$props5 = this.props,
          onChange = _this$props5.onChange,
          isAutoCheckedParent = _this$props5.isAutoCheckedParent,
          oldCheckedIds = _this$props5.value,
          valueType = _this$props5.valueType,
          multiple = _this$props5.multiple,
          unrelated = _this$props5.unrelated;
      var newCheckedIds = [];
      var newCheckIdsMap = {};
      var result = [];

      var _addChildNodeValue2 = function addChildNodeValue() {};

      var finalResult = [];
      var valueIndex = -1;

      if (!treeNode) {
        return;
      }

      if (unrelated) {
        newCheckedIds = (0, _spauiUtils.isArray)(oldCheckedIds) ? (0, _spauiUtils.cloneArray)(oldCheckedIds) : [];
        valueIndex = (0, _spauiUtils.indexOf)(newCheckedIds, treeNode.value);

        if (event.target.checked === false) {
          if (valueIndex > -1) {
            newCheckedIds.splice(valueIndex, 1);
          } // 删除当前节点


          delete this.checkedIdsMap[treeNode.value];
        } else if (event.target.checked === true) {
          if (valueIndex < 0) {
            newCheckedIds.push(treeNode.value);
          }

          this.checkedIdsMap[treeNode.value] = true;
        }

        if (!multiple) {
          // 非单选，只能选中当前点击的这个
          newCheckedIds = [treeNode.value];
        }

        newCheckedIds.map(function (item) {
          result.push(item);
          return item;
        });
      } else {
        if (event.target.checked === false) {
          // 删除当前节点, 删除父节点链条上的节点, 删除当前节点的子节点
          delete this.checkedIdsMap[treeNode.value];
          this.deleteParentsFromCheckedIds(treeNode);
          this.deleteChildsFromCheckedIds(treeNode);
        } else if (event.target.checked === true) {
          // 这里要考虑两种情况, 通过 props.isAutoCheckedParent 开关 来控制
          // 1. 子节点全选, 自动选中父节点, 删除子节点
          // 2. 子节点全选, 不自动选上父节点,  当选上父节点时, 才选择父节点并且删除子节点
          this.checkedIdsMap[treeNode.value] = true;

          if (isAutoCheckedParent) {
            // 情况1,自动选中父节点, 删除子节点
            this.addParentsToCheckedIds(treeNode);
          } else {
            // 情况2,选上当前的节点, 把当前节点的子节点都删除了
            this.deleteChildsFromCheckedIds(treeNode);
          }
        }

        if (!multiple) {
          // 非单选，只能选中当前点击的这个
          newCheckedIds = [treeNode.value];
        } else {
          // newCheckedIds 需要按照用户实际操作的顺序排列id, 分两步: 剔除CheckedIds中已删除的id, 添加新选中的id
          // 先剔除已删除的id
          if ((0, _spauiUtils.isArray)(oldCheckedIds)) {
            newCheckedIds = oldCheckedIds.filter(function (item) {
              return !!_this6.checkedIdsMap[item];
            });
            newCheckedIds.forEach(function (item) {
              newCheckIdsMap[item] = true;
            });
          } // 遍历checkedIdsMap中的新增加的id


          for (var key in this.checkedIdsMap) {
            if (key && !newCheckIdsMap[key] && this.checkedIdsMap[key]) {
              newCheckedIds.push(key);
            }
          }
        }

        if (valueType === 'child') {
          _addChildNodeValue2 = function addChildNodeValue() {
            var parentNodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var childNodeResult = arguments.length > 1 ? arguments[1] : undefined;
            var childrenNodes = parentNodeData.childrenNodes || [];

            if (parentNodeData.value) {
              if (childrenNodes.length < 1) {
                childNodeResult.push(parentNodeData.value);
              } else {
                childrenNodes.map(function (item) {
                  if (item.value && _this6.valueTreeNodeMap[item.value]) {
                    _addChildNodeValue2(_this6.valueTreeNodeMap[item.value], childNodeResult);
                  }

                  return item;
                });
              }
            }
          }; // 回传最底层子节点


          newCheckedIds.map(function (item) {
            _addChildNodeValue2(_this6.valueTreeNodeMap[item] || {}, result);

            return item;
          });
        } else {
          newCheckedIds.map(function (item) {
            if (_this6.valueTreeNodeMap[item] && _this6.valueTreeNodeMap[item].parent_id && (0, _spauiUtils.indexOf)(newCheckedIds, _this6.valueTreeNodeMap[item].parent_id) > -1) {// 如果父节点也是选中的，那子节点这个就不返回了
            } else {
              result.push(item);
            }

            return item;
          });
        }
      } // 最后返回valueTreeNodeMap本身自己的value


      result.map(function (item) {
        if (_this6.valueTreeNodeMap[item] && _this6.valueTreeNodeMap[item].value) {
          finalResult.push(_this6.valueTreeNodeMap[item].value);
        } else {
          finalResult.push(item);
        }

        return item;
      });

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, finalResult, treeNode, this.valueTreeNodeMap);
      }
    }
  }, {
    key: "getShowColumnsCount",
    value: function getShowColumnsCount() {
      var _genNodeTree = genNodeTree(this.props),
          showColumnsCount = _genNodeTree.showColumnsCount;

      var _this$props6 = this.props,
          showAdditionalComponent = _this$props6.showAdditionalComponent,
          AdditionalComponent = _this$props6.AdditionalComponent;
      var result = showColumnsCount;

      if (showAdditionalComponent && typeof AdditionalComponent !== 'undefined') {
        result = result + 1;
      }

      return result;
    }
    /**
     * 渲染树状选择器组件
     * @private
     * @returns {XML}
     * @constructor
     */

  }, {
    key: "genTree",
    value: function genTree() {
      var _this7 = this;

      var _this$props7 = this.props,
          TreeNodeComponent = _this$props7.TreeNodeComponent,
          _this$props7$Checkbox = _this$props7.CheckboxProps,
          CheckboxProps = _this$props7$Checkbox === void 0 ? {} : _this$props7$Checkbox,
          _this$props7$RadioPro = _this$props7.RadioProps,
          RadioProps = _this$props7$RadioPro === void 0 ? {} : _this$props7$RadioPro,
          canSelected = _this$props7.canSelected,
          nodeCheckedClassName = _this$props7.nodeCheckedClassName,
          _this$props7$selectTa = _this$props7.selectTarget,
          selectTarget = _this$props7$selectTa === void 0 ? '' : _this$props7$selectTa,
          _this$props7$multiple = _this$props7.multiple,
          multiple = _this$props7$multiple === void 0 ? true : _this$props7$multiple,
          TreeBranchComponent = _this$props7.TreeBranchComponent,
          asyncGetNodeData = _this$props7.asyncGetNodeData,
          nodeClassName = _this$props7.nodeClassName,
          fieldNames = _this$props7.fieldNames,
          minWidth = _this$props7.minWidth,
          theNumberOfDisplay = _this$props7.theNumberOfDisplay,
          displayItemHeight = _this$props7.displayItemHeight,
          labelFormat = _this$props7.labelFormat,
          disabled = _this$props7.disabled,
          valueType = _this$props7.valueType,
          IconComponent = _this$props7.IconComponent,
          NodeAdditionalComponent = _this$props7.NodeAdditionalComponent,
          AdditionalComponent = _this$props7.AdditionalComponent,
          showAdditionalComponent = _this$props7.showAdditionalComponent,
          setBranchStyle = _this$props7.setBranchStyle,
          _this$props7$useCss = _this$props7.useCss,
          useCss = _this$props7$useCss === void 0 ? false : _this$props7$useCss,
          setBranchClassName = _this$props7.setBranchClassName,
          setNodeClassName = _this$props7.setNodeClassName,
          unrelated = _this$props7.unrelated,
          propsValue = _this$props7.value,
          setBranchTitle = _this$props7.setBranchTitle,
          branchTitleClassName = _this$props7.branchTitleClassName,
          nodeCanExpand = _this$props7.nodeCanExpand,
          setBranchCheckAll = _this$props7.setBranchCheckAll,
          nodeNotAllowSelected = _this$props7.nodeNotAllowSelected,
          checkAll = _this$props7.checkAll,
          checkAllLabel = _this$props7.checkAllLabel,
          CheckAllComponent = _this$props7.CheckAllComponent,
          showNodeTitle = _this$props7.showNodeTitle;
      var classNameMap = this.getClassNameMap();
      var _this$state$showBegin3 = this.state.showBeginIndexMap,
          showBeginIndexMap = _this$state$showBegin3 === void 0 ? {} : _this$state$showBegin3;
      var branchWidthStyle = {},
          key = ''; // 把props.data 转化为 NodeTree 数据对象, 存储了整个树状的数据(树节点以 treeNodeStruct 为模板)

      var _genNodeTree2 = genNodeTree(this.props),
          rootTreeNode = _genNodeTree2.rootTreeNode,
          valueTreeNodeMap = _genNodeTree2.valueTreeNodeMap,
          checkedIdsMap = _genNodeTree2.checkedIdsMap,
          treeDeep = _genNodeTree2.treeDeep;

      var showColumnsCount = this.getShowColumnsCount();

      if (unrelated && propsValue && propsValue.length > 0) {
        for (key in valueTreeNodeMap) {
          if (valueTreeNodeMap[key] && valueTreeNodeMap[key].status === CHECKED) {
            if ((0, _spauiUtils.indexOf)(propsValue, valueTreeNodeMap[key].value) > -1) {
              valueTreeNodeMap[key].status = CHECKED;
            } else {
              valueTreeNodeMap[key].status = UNCHECKED;
            }
          }
        }
      } // 每次生成NodeTree之后, 也要更新this.valueTreeNodeMap this.checkedIdsMap


      this.valueTreeNodeMap = valueTreeNodeMap;
      this.checkedIdsMap = checkedIdsMap; // 生成每个branch的宽度样式, this._showColumnsCount是在 genNodeTree中生成的

      if (!useCss) {
        branchWidthStyle = setBranchStyle(showColumnsCount, -1, this.domRef);
      } // 定义一个branche的列表, 暂存每一列元素, 因为render是递归执行的


      var branches = []; // 渲染一个节点

      var renderOneNode = function renderOneNode(treeNode) {
        // 如果当前的节点是需要展开子节点的, 就调用renderBranch递归遍历渲染
        if (treeNode.isExpand && treeNode.childrenNodes) {
          renderOneBranch(treeNode);
        }

        return TreeNodeComponent({
          treeNode: treeNode,
          fieldNames: fieldNames,
          labelFormat: labelFormat,
          disabled: disabled,
          valueType: valueType,
          onClick: _this7.handleClick,
          onChange: _this7.handleChange,
          nodeCheckedClassName: nodeCheckedClassName,
          CheckboxProps: CheckboxProps,
          RadioProps: RadioProps,
          canSelected: canSelected,
          IconComponent: IconComponent,
          nodeClassName: nodeClassName,
          selectTarget: selectTarget,
          multiple: multiple,
          NodeAdditionalComponent: NodeAdditionalComponent,
          asyncGetNodeData: asyncGetNodeData,
          treeValue: _this7.props.value,
          setNodeClassName: setNodeClassName,
          unrelated: unrelated,
          nodeCanExpand: nodeCanExpand,
          nodeNotAllowSelected: nodeNotAllowSelected,
          showNodeTitle: showNodeTitle
        });
      }; // 渲染一列节点( branch )


      var renderOneBranch = function renderOneBranch(parentNode) {
        branches.unshift(TreeBranchComponent({
          valueTreeNodeMap: valueTreeNodeMap,
          checkAll: checkAll,
          checkAllLabel: checkAllLabel,
          CheckAllComponent: CheckAllComponent,
          nodeNotAllowSelected: nodeNotAllowSelected,
          showNodeTitle: showNodeTitle,
          checkAllProps: {
            fieldNames: fieldNames,
            labelFormat: labelFormat,
            disabled: disabled,
            valueType: valueType,
            nodeCheckedClassName: nodeCheckedClassName,
            canSelected: canSelected,
            nodeClassName: nodeClassName,
            setNodeClassName: setNodeClassName,
            onClick: _this7.handleClick,
            onChange: function onChange(event) {
              _this7.handleCheckAllChange(event, parentNode && parentNode.childrenNodes && parentNode.childrenNodes || []);
            },
            CheckboxProps: CheckboxProps
          },
          multiple: multiple,
          classNameMap: classNameMap,
          setBranchTitle: setBranchTitle,
          setBranchCheckAll: setBranchCheckAll,
          branchTitleClassName: branchTitleClassName,
          displayItemHeight: displayItemHeight,
          theNumberOfDisplay: theNumberOfDisplay,
          parentNode: parentNode,
          branchWidthStyle: branchWidthStyle,
          BranchTreeNodeComponent: renderOneNode,
          onColumnScroll: _this7.handleColumnScroll
        }));
      }; // 从rootTreeNode开始递归遍历, 只需要遍历需要展示的节点
      // 渲染的过程是 是一个自底向上的过程, 最先完成最右的branch, unshift 到 branches数组中


      renderOneBranch(rootTreeNode); // 设置一下是否滚动到最右侧标识, 下一次update的时候, 否超过这个数, 就自动滚动到最右侧

      this.isNeedScrollRight = branches.length > this.lastBranchCount;
      this.lastBranchCount = branches.length; // 树有多深, 就要branches就要有多少个, 先预留几个width为0的空的div占坑, 方便后面从0到width有伸缩的效果, transtion需要触发才能执行

      var emptyBranch = treeDeep - branches.length;

      for (var i = 0; i < emptyBranch; i++) {
        branches.push(TreeBranchComponent({
          classNameMap: classNameMap,
          setBranchTitle: setBranchTitle,
          setBranchCheckAll: setBranchCheckAll,
          branchTitleClassName: branchTitleClassName,
          displayItemHeight: displayItemHeight,
          theNumberOfDisplay: theNumberOfDisplay,
          parentNode: {},
          branchWidthStyle: {
            width: 0,
            borderLeft: 'none'
          },
          BranchTreeNodeComponent: null,
          onColumnScroll: this.handleColumnScroll
        }));
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_defineProperty({}, classNameMap.TreeMoreScopeClassName, showColumnsCount > 3), classNameMap.TreeListClassName),
        ref: function ref(el) {
          _this7.selectListDom = el;
        }
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.TreeListInnerClassName, 'clearfix'),
        style: {
          minWidth: showColumnsCount * minWidth
        },
        ref: function ref(el) {
          _this7.branchWrap = el;
        }
      }, branches.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var _item$props = item.props,
            props = _item$props === void 0 ? {} : _item$props;
        var _props$style = props.style,
            style = _props$style === void 0 ? {} : _props$style,
            _props$className = props.className,
            className = _props$className === void 0 ? '' : _props$className,
            _props$parentNode = props.parentNode,
            parentNode = _props$parentNode === void 0 ? {} : _props$parentNode;
        var newStyle = style,
            newClassName = className; // 如果不为0，需要重新用函数设置下宽度

        if (newStyle.width !== 0 && !useCss) {
          newStyle = setBranchStyle(showColumnsCount, index, _this7.domRef);
        } // 如果指定用css了，那就添加一个空行的className


        if (newStyle.width === 0 && newStyle.borderLeft === 'none' && useCss) {
          newClassName += ' ' + classNameMap.TreeHideScopeClassName;
          delete newStyle.width;
          delete newStyle.borderLeft;
        }

        var result = (0, _react.cloneElement)(item, {
          index: index,
          showBeginIndex: showBeginIndexMap[index + '_' + parentNode.key] || 0,
          key: index,
          style: newStyle,
          className: newClassName + ' ' + setBranchClassName('branch', index, showColumnsCount)
        });
        return result;
      }), showAdditionalComponent && typeof AdditionalComponent !== 'undefined' ? _react["default"].createElement("div", {
        className: classNameMap.TreeScopeClassName + ' ' + setBranchClassName('addition'),
        style: !useCss ? setBranchStyle(showColumnsCount, showColumnsCount - 1, this.domRef) : {}
      }, (0, _spauiUtils.isFunction)(AdditionalComponent) ? _react["default"].createElement(AdditionalComponent, _extends({}, this.props, {
        AdditionalComponent: null
      })) : AdditionalComponent) : null));
    }
    /**
     * 最终渲染
     * @private
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props8 = this.props,
          isLoading = _this$props8.isLoading,
          LoadingComponent = _this$props8.LoadingComponent;
      var classNameMap = this.getClassNameMap();
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: classNameMap.Tree
      }, Tree), {
        ref: function ref(el) {
          _this8.domRef = el;
        }
      }), isLoading ? _react["default"].createElement(LoadingComponent, {
        classNameMap: classNameMap
      }) : this.genTree());
    }
  }]);

  return Tree;
}(_react.PureComponent); // 组件标记


_defineProperty(Tree, "propTypes", _tree_props.propTypes);

_defineProperty(Tree, "defaultProps", _tree_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Tree, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"]));
var _default = Tree;
exports["default"] = _default;